module.exports = __webpack_public_path__ + "img/menuicon.5e4f6b21.svg";